(function() {
  var sortingIsSticky = document.querySelector('[data-sticky-sorting-collection]') || false;
  var ignoreIndex0 = document.querySelector('[data-ignore-index-zero]') || false;
  var scrollToSectionButtons = document.querySelectorAll('[data-sorting-scrollto-index]');
  var headerOffset = Number(WDN.CSSVariable.get('--announcement-height').replace('px','')) + Number(WDN.CSSVariable.get('--header-height').replace('px','')); 
  var sectionsToScrollTo = [].slice.call(document.querySelectorAll('.section-shopping-collection'));
  
  if (sortingIsSticky) headerOffset += sortingIsSticky.getBoundingClientRect().height;
  if (ignoreIndex0) sectionsToScrollTo.shift();
  
  scrollToSectionButtons.forEach(btn => {
    let scrollToIndex = Number(btn.dataset.sortingScrolltoIndex);
    
    btn.addEventListener('click', (e) => {
      var sectionToScrollTo = sectionsToScrollTo[scrollToIndex];
      if (!sectionToScrollTo) return;
      var scrollToTop = sectionToScrollTo.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: scrollToTop - headerOffset,
        left: 0,
        behavior: "smooth",
      });
    });
  });
})();